import Session from '../../entity/session';
import GraphQLClient from "../../core/adapter/graphQLClient";
import HttpClient from '../../core/adapter/httpClient';
import getGuestUser from "./query/getGuestUser";

const STORAGE_GUEST_USER_KEY = 'delivery-guest-session';
const STORAGE_USER_KEY = 'delivery-user-session';

class SessionRepository {
  private graphqlClient: GraphQLClient;
  private httpClient: HttpClient;
  private storage: Storage;

  constructor (
    {
      graphqlClient,
      httpClient,
      storage,
    }: {
      graphqlClient: GraphQLClient;
      httpClient: HttpClient;
      storage: Storage;
    }) {
    this.graphqlClient = graphqlClient;
    this.httpClient = httpClient;
    this.storage = storage;
  }

  public signIn ({
                   email,
                   password,
                 }: {
    email: string;
    password: string;
  }): Promise<Session> {
    return this.httpClient
      .postJson('/tokens/store/user', {
        email, password,
      })
      .then(response => response.data)
      .then(json => {
        const authenticationToken = json['token'];
        const refreshToken = json['refreshToken'];

        return Session.fromJson({ authenticationToken, refreshToken });
      });
  }

  public signOut (): Promise<void> {
    return this.httpClient.deleteJson('/tokens/company/user').then(_ => undefined);
  }

  public async refreshByGuestUser(session: Session | null): Promise<Session> {
    return await this.graphqlClient
      .query(session, getGuestUser)
      .then(({ data }: { data: any }) => Session.fromJson(data['guestUser']));
  }

  public async refreshByUser (session: Session): Promise<Session> {
    const response = await this.httpClient.postJson('/tokens/store/user/refresh_token', {
      token: session.refreshToken,
    });
    const json = await response.data;

    const authenticationToken = json['token'];
    const refreshToken = json['refreshToken'];

    return Session.fromJson({ authenticationToken, refreshToken });
  }

  public getGuestSessionFromStorage (): Session | null {
    const jsonString = this.storage.getItem(STORAGE_GUEST_USER_KEY);

    if (!jsonString) { return null; }

    const json = JSON.parse(jsonString);

    return Session.fromJson(json);
  }

  public writeGuestSessionToStorage (session: Session): void {
    const jsonString = JSON.stringify(session.toJson());

    this.storage.setItem(STORAGE_GUEST_USER_KEY, jsonString);
  }

  public deleteGuestSessionFromStorage (): void {
    this.storage.removeItem(STORAGE_GUEST_USER_KEY);
  }

  public getUserSessionFromStorage (): Session | null {
    const jsonString = this.storage.getItem(STORAGE_USER_KEY);

    if (!jsonString) { return null; }

    const json = JSON.parse(jsonString);

    return Session.fromJson(json);
  }

  public writeUserSessionToStorage (session: Session): void {
    const jsonString = JSON.stringify(session.toJson());

    this.storage.setItem(STORAGE_USER_KEY, jsonString);
  }

  public deleteUserSessionFromStorage (): void {
    this.storage.removeItem(STORAGE_USER_KEY);
  }
}

export default SessionRepository;
